import { createStyles } from '@material-ui/styles'
import { makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      backgroundColor: '#fff',
      display: 'none',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '49px',
      zIndex: 2,
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        alignItems: 'center',
      },
      '&::before': {
        content: 'close-quote',
        position: 'absolute',
        left: 0,
        top: 0,
        display: 'flex',
        right: 0,
        height: '1px',
        backgroundColor: '#EBEEFF',
      },
    },
    footerMenus: {
      zIndex: 1,
      display: 'flex',
      listStyle: 'none',
      justifyContent: 'space-evenly',
      width: '100%',
      padding: 0,
      alignItems: 'center',
      '& > a': {
        textDecoration: 'none',
      },
      // '& > li': {
      //   display: 'flex',
      //   flexDirection: 'column',
      //   alignItems: 'center',
      //   '& svg path': {
      //     fill: '#A1B1CA',
      //   },
      //   fontSize: '12px',
      //   lineHeight: '17px',
      //   fontWeight: 500,
      //   color: '#A1B1CA',
      // },
    },
    footerListItems: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& svg path': {
        fill: theme.variables.deepBlue,
      },
      fontSize: theme.variables.fontSizeXs,
      lineHeight: '14px',
      fontWeight: 400,
      color: theme.variables.deepBlue,
    },
  }),
)

export default useStyles
